// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const PARAMETER_OPTIMIZATION_PREDICTION_STEP_SHAPES = [
  {
    stepType: PipelineStepType.PARAMETER_OPTIMIZATION_PREDICTION,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Model training input': {
        systemName: 'Model training input',
        displayName: 'Model training input',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: true
      },
      'All data': {
        systemName: 'All data',
        displayName: 'All data',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Feature importance': {
        systemName: 'Feature importance',
        displayName: 'Feature importance',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Predictions default values': {
        systemName: 'Predictions default values',
        displayName: 'Predictions default values',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      'Predictions grid': {
        systemName: 'Predictions grid',
        displayName: 'Predictions grid',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      }
    },
    config: null
  },
  {
    stepType: PipelineStepType.PARAMETER_OPTIMIZATION_PREDICTION,
    isDeprecated: false,
    version: 1,
    inputDataShapes: {
      'Model training input': {
        systemName: 'Model training input',
        displayName: 'Model training input',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: true
      },
      'All data': {
        systemName: 'All data',
        displayName: 'All data',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Feature importance': {
        systemName: 'Feature importance',
        displayName: 'Feature importance',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Predictions default values': {
        systemName: 'Predictions default values',
        displayName: 'Predictions default values',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      'Predictions grid': {
        systemName: 'Predictions grid',
        displayName: 'Predictions grid',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      contour_plots_partial_dependence: {
        systemName: 'contour_plots_partial_dependence',
        displayName: 'contour_plots_partial_dependence',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: false
      }
    },
    config: null
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
